import translate from '../../../i18n'
import { ExclamationCircleFilled } from '@ant-design/icons'
import { Button, Modal, Result } from 'antd'

interface IRevokeCampaignPopupModalProps {
  loading: boolean
  visible: boolean
  handleCancel: () => void
  handleOk: () => void
}

const RevokeCampaignPopupModal = (props: IRevokeCampaignPopupModalProps) => {
  const { visible, handleOk, handleCancel, loading } = props

  return (
    <Modal
      centered
      open={visible}
      onOk={handleOk}
      onCancel={handleCancel}
      title={null}
      footer={null}
      width={450}
      styles={{ body: { padding: '24px 80px' } }}
    >
      <Result
        title={translate('campaignPopups.revokeTitle')}
        subTitle={translate('campaignPopups.revokeSubTitle')}
        icon={<ExclamationCircleFilled style={{ color: '#FF4D4F', fontSize: '40px' }} />}
        extra={[
          <Button type="primary" key="back" loading={loading} onClick={handleOk}>
            {translate('campaignPopups.revokeConfirm')}
          </Button>,
          <Button key="submit" onClick={handleCancel}>
            {translate('campaignPopups.revokeCancel')}
          </Button>,
        ]}
      />
    </Modal>
  )
}

export default RevokeCampaignPopupModal
